import { Dialog } from "@verde/compose-ui";
import { DocumentIcon } from "@verde/icons";
import { Button } from "@verde/ui-core";
import React from "react";
import { create } from "zustand";
import type { UseWorkflowTypeModalProps } from "./types";

export const useWorkflowTypeModal = create<UseWorkflowTypeModalProps>((set) => {
  return {
    open: false,
    toggle: () => {
      set((state) => ({ open: !state.open }));
    },
  };
});

function WorkflowTypeModal() {
  const { open, toggle } = useWorkflowTypeModal();
  return (
    <Dialog
      open={open}
      size="sm"
      onClose={toggle}
      header={{
        size: "lg",
        title: "Nova Operação",
        icon: <DocumentIcon />,
        kind: "success",
      }}
    >
      <p className="font-medium text-lg text-neutral-dark-3 mb-6">
        Selecione o tipo de crédito que deseja solicitar.
      </p>
      <div className="grid rounded p-4 gap-3 bg-neutral-light-1">
        <Button
          kind="secondary"
          size="lg"
          className="w-full"
          onClick={() => {
            window.location.replace("/proposta");
          }}
        >
          Crédito Custeio
        </Button>
        <Button
          kind="secondary"
          size="lg"
          className="w-full"
          onClick={() => {
            window.location.replace("/express");
          }}
        >
          Crédito Express
        </Button>
      </div>
    </Dialog>
  );
}

export default React.memo(WorkflowTypeModal);
